import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/AuthContext';
import PageLayout from './components/PageLayout';
import Landing from './pages/Landing';
import Matches from './pages/consult/Matches';
import ConsultAbout from './pages/consult/ConsultAbout';
import Payment from './pages/consult/Payment';
import Profile from './pages/consult/Profile';
import Login from './pages/consult/Login';
import Register from './pages/consult/Register';
import Contact from './pages/Contact';
import DecorAbout from './pages/decor/DecorAbout';
import Catalog from './pages/decor/Catalog';
import DecorQuote from './pages/decor/DecorQuote';
import DecorBooking from './pages/decor/DecorBooking';
import CateringAbout from './pages/catering/CateringAbout';
import Team from './pages/catering/Team';
import Menu from './pages/catering/Menu';
import CateringQuote from './pages/catering/CateringQuote';
import CateringBooking from './pages/catering/CateringBooking';

function Wrap({ children }) {
  return <PageLayout>{children}</PageLayout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"                    element={<Wrap><Landing /></Wrap>} />
          <Route path="/consultation"        element={<Wrap><Matches /></Wrap>} />
          <Route path="/consultation/about"  element={<Wrap><ConsultAbout /></Wrap>} />
          <Route path="/consultation/payment" element={<Wrap><Payment /></Wrap>} />
          <Route path="/consultation/profile" element={<Wrap><Profile /></Wrap>} />
          <Route path="/consultation/login"  element={<Wrap><Login /></Wrap>} />
          <Route path="/consultation/register" element={<Wrap><Register /></Wrap>} />
          <Route path="/contact"             element={<Wrap><Contact /></Wrap>} />
          <Route path="/decor"               element={<Wrap><DecorAbout /></Wrap>} />
          <Route path="/decor/catalog"       element={<Wrap><Catalog /></Wrap>} />
          <Route path="/decor/quote"         element={<Wrap><DecorQuote /></Wrap>} />
          <Route path="/decor/booking"       element={<Wrap><DecorBooking /></Wrap>} />
          <Route path="/catering"            element={<Wrap><CateringAbout /></Wrap>} />
          <Route path="/catering/team"       element={<Wrap><Team /></Wrap>} />
          <Route path="/catering/menu"       element={<Wrap><Menu /></Wrap>} />
          <Route path="/catering/quote"      element={<Wrap><CateringQuote /></Wrap>} />
          <Route path="/catering/booking"    element={<Wrap><CateringBooking /></Wrap>} />
          <Route path="*"                    element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
